import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { UserAccessRepository } from '@app/domain/ports/user-access.repository';
import { UserAccessResult } from '@app/domain/models/user-access.model';

interface UserAccessDto {
  success?: boolean;
  message?: string;
  data?: unknown;
}

@Injectable()
export class UserAccessRemoteDataSource extends UserAccessRepository {
  private readonly http = inject(HttpClient);

  checkAccess(): Observable<UserAccessResult> {
    return this.http
      .get<UserAccessDto>(`${environment.graphqlApiUrl}/user/access`)
      .pipe(map(dto => this.mapToDomain(dto)));
  }

  private mapToDomain(dto: UserAccessDto): UserAccessResult {
    return {
      success: dto.success ?? false,
      message: dto.message ?? '',
      data: dto.data ?? null,
    };
  }
}
